export default __webpack_public_path__ + "static/media/pool3.0b278757.jpg";